import { Box, Container, Divider, Grid, Stack, Typography } from '@mui/material'

import { ContainerCustom, Image } from '@/components'
import { getTimeFromNow } from '@/utils/date-time'
import { getTranslations } from 'next-intl/server'
import { DetailBlog } from '../types'
import { AdsBlogs } from './AdsBlogs'
import { BlogCategories } from './BlogCategories'
import HTMLReactParser from 'html-react-parser/lib/index'
import { NewUpdateCollections } from '../pages/collections/components/new-update-collections'
import { AvtAuthor } from './AvtAuthor'
import { ShareSocials } from './ShareSocials'
import { HEADER_HEIGHT_PX } from '@/constants'
export const BlogDetailContainer = async ({ data }: { data: DetailBlog | null }) => {
  const t = await getTranslations()
  return (
    <>
      <ContainerCustom sx={{ paddingTop: { xs: 1, md: '1rem' }, margin: '0 auto' }}>
        <Grid container spacing={2} sx={{ padding: { xs: '0 0 42px', md: '0 0 96px' } }}>
          {/* <Grid size={{ xs: 12, sm: 5, md: 4, lg: 3.5, xl: 3, xxl: 2.5 }}> */}
          <BlogCategories
            sx={{ top: { xs: HEADER_HEIGHT_PX.TOTAL.xs, md: '32px' }, padding: { xs: '0.5rem', lg: '1rem' } }}
            content={data?.post_content ?? ''}
            gridProps={{ size: { xs: 12, sm: 5, md: 4, lg: 3.5, xl: 3, xxl: 2.5 } }}
          />
          {/* </Grid> */}
          <Grid
            sx={{
              flex: 1,
            }}
            order={{ xs: 2 }}
          >
            {data?.name && (
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '1.5rem', md: '1.875rem', lg: '2.25rem' },
                  fontWeight: 800,
                  lineHeight: { xs: 1.375, xxl: 1.5 },
                }}
              >
                {data?.name}
              </Typography>
            )}
            {data?.author_name && (
              <AvtAuthor authorName={data?.author_name}>
                {data?.publish_date && (
                  <Typography
                    variant="caption"
                    sx={{
                      fontStyle: 'italic',
                      color: '#616161',
                      lineHeight: 1.5,
                    }}
                  >
                    {getTimeFromNow(data?.publish_date)}
                  </Typography>
                )}
              </AvtAuthor>
            )}
            {data?.image && (
              <Box sx={{ maxWidth: '100%' }}>
                <Image
                  src={data?.image}
                  alt={data?.name}
                  sx={{ borderRadius: '4px', mb: 2, width: '100%' }}
                />
              </Box>
            )}
            <Box className="common-content">{HTMLReactParser(data?.post_content ?? '')}</Box>
            {data?.author_name && (
              <Box sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', pb: 2, mt: 2 }}>
                <Divider sx={{ borderColor: '#C2C2C2', mb: 2 }} />
                <AvtAuthor sx={{ m: 0 }} authorName={data?.author_name}>
                  <ShareSocials />
                </AvtAuthor>
              </Box>
            )}
          </Grid>
          <Grid
            sx={{ display: { xs: 'none', xl: 'block' } }}
            size={{ xs: 12, md: 6, xl: 3 }}
            order={{ xs: 3 }}
          >
            <Stack spacing={2} sx={{ position: 'sticky', top: '32px' }}>
              <AdsBlogs />
            </Stack>
          </Grid>
        </Grid>
      </ContainerCustom>
      <NewUpdateCollections
        showPagination={false}
        title={t('Bài Viết liên quan')?.toUpperCase()}
        pageSize={10}
      />
    </>
  )
}
